import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';

gsap.registerPlugin( ScrollTrigger, CustomEase );

( function( app ) {
  function splitIntoLines( el ) {
    if ( el.dataset.linesSplit === 'true' ) {
      return [...el.querySelectorAll( '.wysiwyg-line-inner' )];
    }

    el.dataset.linesSplit = 'true';

    const words = el.innerText.trim().split( /\s+/ );
    el.innerHTML = '';

    const lineMap = [];
    const measurer = document.createElement( 'span' );

    measurer.style.position = 'absolute';
    measurer.style.visibility = 'hidden';
    measurer.style.pointerEvents = 'none';
    measurer.style.whiteSpace = 'normal';
    measurer.style.width = `${el.offsetWidth}px`;
    measurer.style.font = window.getComputedStyle( el ).font;

    document.body.appendChild( measurer );

    words.forEach( ( word ) => {
      const span = document.createElement( 'span' );
      span.textContent = `${word} `;
      measurer.appendChild( span );

      const top = span.offsetTop;
      const last = lineMap[lineMap.length - 1];

      if ( !last || last.top !== top ) {
        lineMap.push( {
          top,
          words: [word],
        } );
      } else {
        last.words.push( word );
      }
    } );

    measurer.remove();

    lineMap.forEach( ( lineData ) => {
      const line = document.createElement( 'span' );
      line.className = 'wysiwyg-line';

      const inner = document.createElement( 'span' );
      inner.className = 'wysiwyg-line-inner';
      inner.innerText = lineData.words.join( ' ' );

      line.appendChild( inner );
      el.appendChild( line );
    } );

    return [...el.querySelectorAll( '.wysiwyg-line-inner' )];
  }

  function wrapTextNode( node ) {
    const p = document.createElement( 'p' );
    p.textContent = node.textContent;
    node.parentNode.replaceChild( p, node );

    return p;
  }

  function getBouncyChildren( container ) {
    return Array.from( container.childNodes ).filter(
        ( node ) => !( node.nodeType === Node.TEXT_NODE && !node.textContent.trim() ),
    );
  }

  function getTargets( node ) {
    if ( node.nodeType === Node.TEXT_NODE && node.textContent.trim() ) {
      node = wrapTextNode( node );
    }

    if ( node.nodeType !== Node.ELEMENT_NODE ) return [];

    if ( node.classList.contains( 'wysiwyg' ) ) {
      return splitIntoLines( node );
    }

    return [node];
  }

  function animateItem( item ) {
    if ( item.dataset?.bouncyAnimated === 'true' ) return;

    if ( item.dataset ) {
      item.dataset.bouncyAnimated = 'true';
    }

    if ( item.nodeType === Node.ELEMENT_NODE && item.classList.contains( 'vertical-line' ) ) {
      gsap.fromTo(
          item,
          {
            scaleY: 0,
            transformOrigin: 'top center',
          },
          {
            scaleY: 1,
            duration: 0.5,
            ease: 'power2.out',
          },
      );

      return;
    }

    const targets = getTargets( item );

    if ( !targets.length ) return;

    gsap.fromTo(
        targets,
        {
          opacity: 0,
          y: 26,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.75,
          ease: 'back.out(1.7)',
          stagger: 0.05,
        },
    );
  }

  function prepareItem( item ) {
    if ( item.nodeType !== Node.ELEMENT_NODE ) return;

    if ( item.classList.contains( 'vertical-line' ) ) {
      gsap.set( item, {
        scaleY: 0,
        transformOrigin: 'top center',
        display: 'block',
      } );

      return;
    }

    if ( item.classList.contains( 'wysiwyg' ) ) return;

    gsap.set( item, {
      opacity: 0,
      y: 26,
    } );
  }

  const COMPONENT = {
    animate: function() {
      if ( window.matchMedia( '(prefers-reduced-motion)' ).matches ) return;

      $( '.js-fade:not(.js-ignore), .js-reveal:not(.js-ignore), .js-fade-group' ).each( function() {
        ScrollTrigger.create( {
          trigger: this,
          start: 'top 95%',
          once: true,
          onEnter: () => $( this ).addClass( 'js-animated' ),
        } );
      } );

      document.querySelectorAll( '.js-bouncy-group' ).forEach( ( container ) => {
        gsap.set( container, {autoAlpha: 1} );

        const children = getBouncyChildren( container );

        children.forEach( ( child ) => {
          prepareItem( child );

          ScrollTrigger.create( {
            trigger: child.nodeType === Node.ELEMENT_NODE ? child : container,
            start: 'top 95%',
            once: true,
            invalidateOnRefresh: true,
            onEnter: () => animateItem( child ),
          } );
        } );
      } );

      ScrollTrigger.refresh();
    },

    onError: function() {
      document.querySelectorAll( '.js-fade' )?.forEach( ( el ) => el.classList.remove( 'js-fade' ) );

      document.querySelectorAll( '.js-bouncy-group' )?.forEach( ( el ) => {
        gsap.set( el, {autoAlpha: 1} );
      } );
    },
  };

  app.registerComponent( 'animations', COMPONENT );
} )( app );
